import { makeStyles } from '@material-ui/core/styles';
import { green, amber } from '@material-ui/core/colors/'

const styles = theme => ({
  content: {
    [theme.breakpoints.down('sm')]: {
      bottom: 0,
      left: 0,
      width: '85%'
    },
    position: 'fixed',
    bottom: 50,
    left: 50,
    zIndex: 5
  },
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: 15
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
})

export default makeStyles(styles)
